import { deviceId } from '../utils/device';
/**
 * 百度sem买量接入埋点
 */

function semTracker() {
  console.log('semTracker start');
}
// 项目id
semTracker.appId = '200001566'; // 和买量的同学确认, 手动填入
// 项目对应买量id
semTracker.btAppId = 'cffbd7f42e0f'; // 和买量的同学确认, 手动填入
// 设备id 用于标识用户, 需要自行在 web 端自动创建并管理唯一 device id 标识
semTracker.deviceId = deviceId;

/**
 * 获取特定格式的随机id
 * @returns {string}
 * @private
 */
semTracker._guid = function() {
  return semTracker._s4n(3) + '-' + semTracker._s4n(1) + '-' + semTracker._s4n(1) + '-' + semTracker._s4n(3);
};
semTracker._s4n = function(n) {
  var result = '';
  for (var i = 0; i < n; i++) {
    result = result + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return result;
};

/**
 * 把值保存到本地存储
 * @param key
 * @param value
 */
semTracker.setLocalStorage = function(key, value) {
  localStorage.setItem(key, value);
};

/**
 * 从本次存储里取出指定的值
 * @param key
 * @returns {string}
 */
semTracker.getLocalStorage = function(key) {
  return localStorage.getItem(key);
};

/**
 * 检验当前埋点必须的id是否正常接入
 * @returns {boolean}
 */
semTracker.validateNecessaryId = function() {
  if (semTracker.btAppId && semTracker.appId) {
    return true;
  }
  alert('请确认买量埋点必须的appid和btappid是否完整正确!');
  return false;
};

/**
 * 初始化信息
 */
semTracker.initMsg = function() {
  semTracker.deviceId = semTracker.getLocalStorage('semTracker.deviceId');
  if (!semTracker.deviceId) {
    semTracker.deviceId = semTracker._guid();
    semTracker.setLocalStorage('semTracker.deviceId', semTracker.deviceId);
  }
};

/**
 * 发送买量埋点
 * @param msgType 事件/消息类型
 * @param eventId 数据指标参数
 * @param context 数据指标描述
 */
semTracker.send = function({ msgType = 'custom.event', eventId, _btcode, bd_vid, web_url }) {
  var requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      // eslint-disable-next-line no-restricted-globals
      url: location.href,
      appId: semTracker.appId,
      btAppId: semTracker.btAppId,
      deviceId: semTracker.deviceId,
      msgType: msgType,
      eventId: eventId,
      _btcode: _btcode,
      bd_vid: bd_vid,
      web_url: web_url
    })
  };
  var requestOptionsDecode = encodeURIComponent(requestOptions.body);
  if (semTracker.validateNecessaryId()) {
    return fetch('https://sdkserver.seasungame.com/api/clue?body=' + requestOptionsDecode).then(response => response.json());
  }
};

export { semTracker };
